<template>
  <div class="tab__content">
    <div class="container fluid grid-list-lg pa-0">
      <div class="layout column ma-0" v-if="match">
        <div class="flex d-flex row align-center match-header">
          <div class="match__info">
            <div class="caption">Комната матча #{{ match.id }}</div>
            <MatchType
              :description="matchStatusDesrc"
              :status-group="matchStatusGroup"
            />
            <MatchStatus
              :match="match"
              :description="matchStatusDesrc"
              :status-group="matchStatusGroup"
            />
          </div>

          <MatchResult
            :protest="!isReferee && matchStatus === 'protest'"
            :score="[
              match.player1 ? match.player1.score : 0,
              match.player2 ? match.player2.score : 0
            ]"
          />

          <div class="match__winner">
            <div v-if="matchFormat" class="match__format">
              Формат: <b>{{ matchFormat }}</b>
            </div>
            <AppBtn
              v-if="isReferee && matchStatus === 'protest'"
              @click="showMatchResultChanger"
              color="red"
              style="padding: 12px;"
              >Решить спор</AppBtn
            >

            <span
              v-else-if="isParticipant && matchStatus === 'started'"
              class="match__result_setter"
            >
              <AppBtn
                v-if="secondMatchStatus == 'confirmed_score_side'"
                disabled
                round
                color="blue-grad"
              >
                Вы указали счет
              </AppBtn>
              <AppBtn
                v-else
                round
                color="blue-grad"
                @click="showMatchResultChanger"
              >
                {{
                  secondMatchStatus == "should_confirm_score_side"
                    ? "Подтвердите результат"
                    : "Указать результат"
                }}
              </AppBtn>
            </span>

            <div
              v-else-if="winner && matchStatusGroup.includes('ended')"
              class="ellipsis"
              :class="{ [winner.team]: true }"
            >
              <span class="ellipsis">{{ winner.nickname }}</span>
              <b class="ml-2">WON</b>
            </div>

            <div v-else class="match__winner_empty">NO Winner</div>
          </div>
        </div>
        <template v-if="match">
          <div class="match__participants">
            <div class="tournament__member team_red">
              <AppBtn
                link
                target="_blank"
                :href="
                  (match.player1 &&
                    match.player1.steam_id64 &&
                    `https://steamcommunity.com/profiles/${match.player1.steam_id64}/`) ||
                    null
                "
                class="pa-0 tournament__member_name ellipsis"
              >
                {{ (match.player1 && match.player1.nickname) || "Пустой слот" }}
              </AppBtn>
              <div class="tournament__member_country ellipsis">
                {{ match.player1 && match.player1.country | country("&nbsp;") }}
              </div>
              <AppBtn
                link
                target="_blank"
                :href="
                  (match.player1 &&
                    match.player1.steam_id64 &&
                    `https://steamcommunity.com/profiles/${match.player1.steam_id64}/`) ||
                    null
                "
                class="pa-0 tournament__member__ava tournament__member__ava_red"
              >
                <img
                  v-if="match.player1 && match.player1.avatar"
                  :src="match.player1.avatar"
                  alt="avatar"
                />
                <SvgIcon v-else size="80%" name="user-light" />
              </AppBtn>
            </div>

            <div class="tournament__member team_blue">
              <AppBtn
                link
                target="_blank"
                :href="
                  (match.player2 &&
                    match.player2.steam_id64 &&
                    `https://steamcommunity.com/profiles/${match.player2.steam_id64}/`) ||
                    null
                "
                class="pa-0 tournament__member_name ellipsis"
              >
                {{ (match.player2 && match.player2.nickname) || "Пустой слот" }}
              </AppBtn>
              <div class="tournament__member_country ellipsis">
                {{ match.player2 && match.player2.country | country("&nbsp;") }}
              </div>
              <AppBtn
                link
                target="_blank"
                :href="
                  (match.player2 &&
                    match.player2.steam_id64 &&
                    `https://steamcommunity.com/profiles/${match.player2.steam_id64}/`) ||
                    null
                "
                class="pa-0 tournament__member__ava tournament__member__ava_blue"
              >
                <img
                  v-if="match.player2 && match.player2.avatar"
                  :src="match.player2.avatar"
                  alt="avatar"
                />
                <SvgIcon v-else size="80%" name="user-light" />
              </AppBtn>
            </div>
          </div>

          <HeroesPick v-if="showHeroes && tournament" :match="match" />

          <div class="match__column">
            <MatchChat
              :room="routeParams.match_id"
              :participant="isParticipant"
              :player1="match.player1"
              :player2="match.player2"
              :can-write="
                matchStatusGroup.includes('live') &&
                  (isParticipant || isReferee)
              "
              :class="[matchStatus].concat(matchStatusGroup)"
            >
              <template
                #warning
                v-if="['protest'].includes(matchStatus) && secondMatchStatus"
              >
                <p class="title">ВНИМАНИЕ!</p>
                <p v-if="secondMatchStatus == 'scores_are_different'">
                  Результаты указанные игроками матча&nbsp;&mdash;
                  не&nbsp;совпадают.<br />
                  Прикрепите, пожалуйста, скриншоты результата игры, чтобы судья
                  смог принять решение.
                </p>
                <p v-if="secondMatchStatus == 'score_not_confirmed'">
                  Результаты матча не&nbsp;были подтверждены одной
                  из&nbsp;сторон.<br />
                  Прикрепите, пожалуйста, скриншоты результата игры, чтобы судья
                  смог принять решение.
                </p>
                <p v-if="secondMatchStatus == 'invited_referee'">
                  Один из&nbsp;участников матча пригласил судью в&nbsp;чат.<br />
                  Матч переведен в&nbsp;статус <b>&laquo;Протест&raquo;</b>.
                </p>
              </template>
              <template #info v-else-if="matchStatusGroup.includes('live')">
                <div class="chat-instruction">
                  <div
                    class="chat-instruction__title"
                    @click="expanded = !expanded"
                  >
                    <span class="mr-2">Инструкция по проведению матча</span>
                    <div
                      class="chat-instruction__caret"
                      :class="{ closed: !expanded }"
                    >
                      <SvgIcon size="10" name="caret-down" />
                    </div>
                  </div>
                  <ExpandTransition>
                    <div v-if="expanded" class="chat-instruction__content">
                      <p>
                        1. Проведите баны и пики в комнате матча.<br />
                        2. В&nbsp;чате Вам необходимо договориться, кто создает
                        лобби<br />
                        3. Зайдите в&nbsp;игру, в&nbsp;верхнем меню выберите
                        вкладку &laquo;Игротека&raquo;<br />
                        4. Начните игру и на вопрос "Start a new hero draft?" -
                        ответьте "No" и выберите героя, который выпал на
                        сайте.<br />
                        5. Нажмите кнопку &laquo;Установить&raquo;, если карта
                        у&nbsp;вас еще не&nbsp;установлена. Если карта уже
                        установлена&nbsp;&mdash; нажмите кнопку &laquo;Создать
                        лобби&raquo; <br />
                        6. Создайте лобби с&nbsp;паролем, который указан
                        на&nbsp;странице матча на&nbsp;сайте<br />
                        7. Начните игру<br />
                        8. По&nbsp;окончанию матча каждый игрок должен сделать
                        скриншот результата<br />
                        9. Укажите результат матча на&nbsp;сайте. Если
                        вы&nbsp;укажите разный счет, автоматически будет вызван
                        судья и&nbsp;вам потребуется предъявить скриншот
                        с&nbsp;результатом
                      </p>
                      <p>
                        У&nbsp;вас есть 10&nbsp;минут, чтобы создать лобби
                        и&nbsp;оповестить об&nbsp;этом в&nbsp;чате.<br />
                        Игру необходимо начать в&nbsp;течении 5&nbsp;минут после
                        создания лобби.
                      </p>
                      <!-- <p>
                        1. В&nbsp;чате Вам необходимо договориться, кто создает лобби<br />
                        2. Создайте лобби с&nbsp;заданным названием и&nbsp;паролем<br />
                        3. Начните игру и&nbsp;укажите счет по&nbsp;окончанию матча<br />
                        4. Каждый игрок должен сделать скриншот результата<br />
                        5. Укажите результат после окончания матча<br />
                        6. На&nbsp;выставление счёта даётся 3&nbsp;минуты<br />
                        7. Если соперник не&nbsp;явился в&nbsp;течении 10&nbsp;минут, то&nbsp;вызывайте админа
                      </p>
                      <p>
                        *Если вы&nbsp;не&nbsp;умеете создавать лобби в&nbsp;Dota&nbsp;2, нажмите <AppBtn @click="showInstruction" link>Сюда</AppBtn> и&nbsp;посмотрите небольшую инструкцию
                      </p> -->
                    </div>
                  </ExpandTransition>
                </div>
              </template>

              <template
                #lobby
                v-if="
                  matchStatusGroup.includes('live') &&
                    (isParticipant || isReferee)
                "
              >
                <div class="match__lobby_info">
                  <!-- <div class="flex">
                    <div class="chat__wrap">
                      <div class="label">Название лобби:</div>
                      <div class="field">{{ match.lobby_name }}</div>
                    </div>
                  </div> -->
                  <div class="flex">
                    <div class="chat__wrap" v-if="match.lobby_password">
                      <div class="label">Пароль для лобби:</div>
                      <div class="field">{{ match.lobby_password }}</div>
                    </div>
                  </div>
                </div>
              </template>

              <template #header>
                <div class="title">Чат</div>
                <AppBtn
                  v-if="
                    (isParticipant || isReferee) &&
                      matchStatusGroup.includes('can_protest')
                  "
                  round
                  color="red-grad"
                  class="invite_admin text-none"
                  @click="inviteReferee"
                >
                  Протест
                </AppBtn>
              </template>
            </MatchChat>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import matchService from "@/services/match";
import showAlert from "@/services/common/showAlert";

import LobbyInstructionModal from "@/components/tournament/LobbyInstructionModal";
import MatchResultModal from "@/components/tournament/MatchResultModal";

import MatchChat from "@/components/chat/MatchChat";
import HeroesPick from "@/components/match/heroes/HeroesPick";
import { ExpandTransition } from "@/components/common/transitions";

import MatchStatus from "@/components/match/MatchStatus";
import MatchType from "@/components/match/MatchType";
import MatchResult from "@/components/match/MatchResult";

const matchFormats = {
  1: "БО1",
  2: "БО3",
  3: "БО5"
};

export default {
  components: {
    MatchChat,
    ExpandTransition,
    HeroesPick,
    MatchStatus,
    MatchType,
    MatchResult
  },

  data: () => ({
    expanded: true,

    loading: false,
    processing: false,
    isParticipant: false,

    matchStatus: null,
    matchStatusDesrc: null,
    matchStatusGroup: []
  }),

  computed: {
    ...mapGetters(["routeParams"]),
    ...mapGetters("tournaments", ["match", "secondMatchStatus", "tournament"]),
    ...mapGetters("auth", ["isAuthenticated", "isRegistred", "isReferee"]),

    matchFormat() {
      return matchFormats[this.match.format] || "";
    },

    showHeroes() {
      return this.match.pick_ban_info;
    },

    winner() {
      if (!this.match.winner || !this.match[`player${this.match.winner}`])
        return false;
      return {
        team:
          this.match.winner === 2 ? "match__winner_blue" : "match__winner_red",
        nickname: this.match[`player${this.match.winner}`].nickname
      };
    }
  },

  watch: {
    routeParams: "fetchPageData",
    match: {
      handler() {
        if (this.match) {
          this.setMatchStatuses(this.match);
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    async showMatchResultChanger() {
      if (this.loading) return;
      this.loading = true;

      const match = this.match;
      const scores = {
        player1: 0,
        player2: 0
      };

      if (this.matchStatus !== "protest" && !this.isReferee) {
        const res = await matchService.getScore(this.routeParams.match_id);

        if (!res.success) {
          showAlert(res.message, 2500);
          this.loading = false;
          return false;
        } else {
          scores.player1 = res.player1_score;
          scores.player2 = res.player2_score;
        }
      }

      this.$modals.open({
        name: "match-result-changer",
        component: MatchResultModal,
        props: {
          scores,
          match
        }
      });

      this.loading = false;
    },

    async inviteReferee() {
      let id = this.routeParams.match_id;
      let data = await matchService.inviteReferee(id);
      await this.$store.dispatch("tournaments/fetchMatch", id);

      showAlert(data.message, 2500);
    },

    async fetchPageData() {
      if (this.loading) return;
      this.loading = true;

      let id = this.routeParams.match_id;

      this.$store.commit("tournaments/CLEAR_MATCH");
      await this.$store.dispatch("tournaments/fetchMatch", id);

      if (this.isAuthenticated && this.isRegistred) {
        this.isParticipant = await matchService.checkParticipant(id);
      }

      this.loading = false;
      this.$store.dispatch("tournaments/updateTournament");
    },

    async onOpenedNotification({ options }) {
      let id = this.routeParams.match_id;

      if (options.name == "notification-modal") {
        const { showBtns } = options.props;
        if (!showBtns) {
          await this.$store.dispatch("tournaments/fetchMatch", id);
        }
      }
    },

    setMatchStatuses(match) {
      this.matchStatus = matchService.getStatus(match.status);
      this.matchStatusDesrc = matchService.getStatusDescription(match.status);
      this.matchStatusGroup = matchService.getStatusGroup(match.status);
    },

    showInstruction() {
      this.$modals.open({
        name: "lobby-instruction",
        component: LobbyInstructionModal
      });
    }
  },

  beforeDestroy() {
    this.$modals.$off("modals:opened", this.onOpenedNotification);
  },

  created() {
    this.fetchPageData();
    this.$modals.$on("modals:opened", this.onOpenedNotification);
  }
};
</script>

<style lang="scss">
.chat-instruction {
  &__title {
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 20px;

    span {
      transition: 0.2s;
      border-bottom: 1px dashed transparent;
    }

    &:hover {
      color: lighten(#7f8492, 20%);

      span {
        border-bottom: 1px dashed;
      }
    }
  }

  &__caret {
    display: inline-block;

    svg {
      transition: 0.2s;
      transform-origin: center;
    }

    &.closed svg {
      transform: rotate(-90deg);
    }
  }

  &__content {
    p:last-child {
      margin-bottom: 0;
    }
  }
}

.match {
  &__info {
    display: flex;
    flex-direction: column;
    // width: 100%;
    flex: 1 1 40% !important;
  }

  &__column {
    width: 100%;
    max-width: 790px;
    margin: 0 auto;
    min-height: 350px;
    @include breakpoint("md-and-down") {
      min-height: auto;
    }
  }

  &__participants {
    display: flex;
    justify-content: space-between;
    padding: 8px;
  }

  &__winner {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    flex: 1 1 40% !important;
    max-width: 40%;

    .match__format {
      flex: 1 1 100%;
      text-align: right;
      border-radius: 6px;
      padding: 13px 28px;
    }

    &_empty {
      background: lighten(#161e36, 5%);
      border-radius: 6px;
      padding: 13px 28px;

      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      max-width: 100%;
    }

    &_red,
    &_blue {
      font-weight: normal;
      padding: 13px 28px;
      border-radius: 6px;
      max-width: 90%;

      span {
        display: inline-block;
        vertical-align: bottom;
        max-width: 80%;
      }
    }

    &_red {
      background: #e72f31;
    }

    &_blue {
      background: #1480b2;
    }

    @include breakpoint("xs-only") {
      justify-content: space-between;

      &_empty,
      &_red,
      &_blue,
      .match__format {
        flex: 0 0 auto;
      }
    }
  }

  &__lobby_info {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin: 0 -15px;
    margin-bottom: 30px;

    > .flex {
      flex: 1 1 50%;
      padding: 0 15px !important;
    }

    .chat__wrap {
      padding-top: 15px;

      .label {
        user-select: none;
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 8px;
      }

      .field {
        background: rgba(0, 10, 37, 0.5);
        color: #fff;
        font-weight: 800;
        font-size: 20px;
        line-height: 109%;
        letter-spacing: 0.02em;
        border-radius: 6px;
        padding: 0px 16px;
        min-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.team_red,
.team_blue {
  display: flex;
  flex: 1 1 auto;
  max-width: 110px;
  min-width: 110px;

  &.tournament__member {
    background: none;
    padding: 0;
    border-radius: 0;
    flex-direction: column;
    align-items: flex-start;
  }

  .tournament__member {
    &_name,
    &_country,
    &__ava {
      width: 100%;
      min-width: 0;
      max-width: 110px;
    }

    &_country {
      height: 1em;
    }

    &__ava {
      margin: 0 !important;
      margin-top: 8px !important;
      height: 110px;
      transition: 0.3s;

      display: flex;
      align-items: center;
      justify-content: center;

      img,
      svg {
        display: block;
        width: 100%;
      }

      svg {
        margin: 0;
        width: 80%;
      }

      .btn__content {
        justify-content: center;
      }

      &:active {
        opacity: 0.6;
      }
    }
  }
}

.team_red {
  margin-right: 15px;
  text-align: left;

  .tournament__member__ava {
    &:hover {
      border-color: #ffd0d1;
      box-shadow: 0px 0px 20px #ff4749;
    }
  }
}
.team_blue {
  margin-left: 15px;
  text-align: right;

  .tournament__member__ava {
    &:hover {
      border-color: #b3e7ff;
      box-shadow: 0px 0px 20px #1480b2;
    }
  }
}

@include breakpoint("xs-only") {
  .match-header {
    flex-wrap: wrap;

    .match__info {
      flex: 1 1 100% !important;
      max-width: 100% !important;
      order: 1;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .match__winner {
      order: 2;
    }
    .match__result {
      order: 3;
    }
    .match__winner,
    .match__result {
      flex: 1 1 100% !important;
      max-width: 100% !important;
      justify-content: center;
    }

    .match__winner_red,
    .match__winner_blue {
      max-width: 100%;
      display: flex;

      span {
        max-width: 100%;
      }
    }
  }
}
</style>
